import { zodResolver } from '@hookform/resolvers/zod';
import { useForm } from 'react-hook-form';
import { z } from 'zod';
import { CustomerUser } from '@ansvar-sakerhet/api-client';

export const editCustomerUserForm = z
  .object({
    firstName: z.string().min(1, 'Namn måste anges'),
    lastName: z.string().min(1, 'Efternamn måste anges'),
    hidden: z.boolean(),
    hasAllProjectAccess: z.boolean(),
    projectIds: z.array(z.string()),
  })
  .superRefine((data, ctx) => {
    if (!data.hasAllProjectAccess && data.projectIds.length === 0) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: 'Välj minst ett projekt',
        path: ['projectIds'],
      });
    }
  });

export type editCustomerUserFormValues = z.infer<typeof editCustomerUserForm>;

export const useEditCustomerUserForm = ({
  user,
  projectIds,
}: {
  user: CustomerUser;
  projectIds: string[];
}) => {
  return useForm<editCustomerUserFormValues>({
    mode: 'onTouched',
    resolver: zodResolver(editCustomerUserForm),
    values: {
      firstName: user.firstName,
      lastName: user.lastName,
      hidden: user.hidden,
      hasAllProjectAccess: user.hasAllProjectAccess,
      projectIds,
    },
  });
};
